import { useEffect } from 'react';
import { PERMISSIONS } from 'store/baseConfig';
import { ProfileSection, ContractDate, CompanyList } from './sub-sections/index';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/system';
import { setCompanyMenuItems } from 'store/slice/SliceHeaderData';
import { selectIsMobile } from 'store/slice/SliceSidebar';

const HeaderSections = () => {
    const { loginState, loginUserInfo } = useSelector((state) => state.auth);
    const { companyMenuItems, selectCompanyNo, contractDate } = useSelector(state => state.header);
    const isMobile = useSelector(selectIsMobile);
    const dispatch = useDispatch();

    const userInfo = loginUserInfo?.user;
    const perm = userInfo ? userInfo.perm_id : '31'; // 권한 id (관리자:01, 운영자:11, 사용자:21)
    const userName = userInfo ? userInfo.login_id : '알수 없음';
    const userCompanyName = userInfo ? userInfo.corp_nm : '알수 없음';

    let userRole = '사용자';

    useEffect(() => {

        switch (perm) {
            case PERMISSIONS.SUPER_ADMIN:
                userRole = '관리자';
                break;
            case PERMISSIONS.ADMIN:
                userRole = '운영자';
                break;
            case PERMISSIONS.USER:
                userRole = '사용자';
                break;
            default:
                userRole = '사용자';
        }
    }, [dispatch, loginState]);

    useEffect(() => {
        if (loginState && loginUserInfo?.user?.perm_id === PERMISSIONS.SUPER_ADMIN) {
            dispatch(setCompanyMenuItems());
        }
    }, [dispatch, loginState, loginUserInfo]);

    if (!loginState) {
        return (<></>);
    }

    switch (perm) {
        case PERMISSIONS.SUPER_ADMIN:
            userRole = '관리자';
            break;
        case PERMISSIONS.ADMIN:
            userRole = '운영자';
            break;
        case PERMISSIONS.USER:
            userRole = '사용자';
            break;
        default:
            userRole = '사용자';
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {perm === PERMISSIONS.SUPER_ADMIN ? <CompanyList /> : null}
            {!isMobile && (perm === PERMISSIONS.SUPER_ADMIN || perm === PERMISSIONS.ADMIN) ? <ContractDate /> : null}
            <ProfileSection perm={perm} userName={userName} userRole={userRole} userCompanyName={userCompanyName} />
        </Box>
    );
};

export default HeaderSections;
